<template>
  <v-footer color="primary-600" padless>
    <v-row justify="center" no-gutters>
      <v-col class="primary mt-3 text-center white--text" cols="12">
        <v-divider inset dark class="mx-auto" color="#D3BC8D"></v-divider>
        <!-- <span class="caption">RECURSOS</span> -->
        <v-btn
        v-for="(item, index) in categorias"
        :key="index"
        color="white"
        text
        class="my-2 rounded-md"
        small
        @click="
          idSubCat(item.CodigoDiv, item.CodigoDep, item.Categoria);
          CLR_DATOS_SUBCAT();
          CLR_BUSCARPROMO();
          CLR_BUSCARSCAT();
          CLR_BUSCARMARCA();
          CLR_BUSCAREPUESTO();
        "
        :to="`/subcategoria/${item.CodigoDiv}/${item.CodigoDep}/${item.Categoria}`"
      >
        {{ item.Nombre }}
      </v-btn>
       
        <v-btn
          text
          dark
          small
          href="https://mail.domosa.com:2096"
          target="_blank"
        >
          CORREO DOMOSA
        </v-btn>
      </v-col>
      <v-col class="font-weight-regular primary py-2 text-center white--text" cols="12">
        <router-link to="/">
          <v-img
            contain
            @click="
              toTopGo();
              CLR_BUSCAREPUESTO();
            "
            :src="`${domoapi2_img}Cia/15/logo?archivo=4.png`"
        
            class="mx-auto"
            :width="$vuetify.breakpoint.name === 'xs' ? 180 : 160"
          ></v-img> </router-link
        >&copy; Todos los derechos reservados
        {{ new Date().getFullYear() }}
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    ...mapActions(["consolidadoSCategoria"]),
    ...mapMutations([
      "CLR_DATOS_SUBCAT",
      "CLR_BUSCARMARCA",
      "CLR_BUSCAREPUESTO",
      "GET_BUSCARCAT",
      "CLR_BUSCARSCAT",
      "CLR_BUSCARPROMO",
      "CLR_ERROR_AXIOS",
      "set_varCategorias",
      "CLR_DATOS_SUBCATB",
      "set_changeSubcatF",
      "CLR_DATOS_ART",
      "set_AdPromoF",
    ]),
    toTopGo() {
      window.scrollTo(0, 0);
      this.set_AdPromoF();
    },
    idSubCat(Div, Dep, Cat) {
      this.GET_BUSCARCAT(Cat);
      window.scrollTo(0, 0);
      this.CLR_ERROR_AXIOS();
      this.CLR_DATOS_SUBCATB();
      this.CLR_BUSCAREPUESTO();
      this.set_changeSubcatF();
      this.CLR_DATOS_ART();
      // this.CLR_PROMO();
      this.set_AdPromoF();
      this.set_varCategorias([Div, Dep, Cat]);
     // if (!this.$route.params.codart) this.consolidadoSCategoria();
      if (this.$route.params.cat)
        //  console.log("f5");
        this.dialog = false;
    },
  },
  computed: {
    ...mapState(["maestro","domoapi2_img"]),
    categorias() {
      if (Object.entries(this.maestro).length !== 0) {
        return this.maestro.ttCategoria;
      }
    },
  },
};
</script>

<style scoped>
.hcolor {
  background-color: #111111;
}
.hcolorsup {
  background-color: #191919;
}
</style>
